import { render, staticRenderFns } from "./ConferenceLaunch.vue?vue&type=template&id=01978a9c&"
import script from "./ConferenceLaunch.vue?vue&type=script&lang=js&"
export * from "./ConferenceLaunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports